import React from 'react';
import { Link } from 'react-router-dom';
import NumberCounter from 'number-counter';

function Aboutarea() {

  const sectionsData = [
    {
      title: 'Success Rate',
      count: 99,
      duration: 3,
      description: 'We rapidly prototype and launch custom apps with no-code tools that move your business forward.',
    },
    {
      title: 'Process Automation',
      count: 100,
      duration: 4,
      description: 'We rapidly prototype and launch custom apps with no-code tools that move your business forward.',
    },
    {
      title: 'Cost Savings',
      count: 45,
      duration: 2,
      description: 'We rapidly prototype and launch custom apps with no-code tools that move your business forward.',
    },
  ];

  return (
    <>
      <section className="about-area about-p pt-120 pb-120 p-relative fix">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-8">
              <div className="section-title center-align mb-80 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                <h5>since from 2000</h5>
                <h2>We combine design, development, business process and data insights to accelerate digital transformations</h2>
              </div>
            </div>
          </div>
          <div className="row bdr">
            {sectionsData.map((section, index) => (
              <div key={index} className="col-lg-4 col-md-12 col-sm-12 wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s" >
                <div className="about-box text-center">
                  <div className="counter number">
                    <h3 className="count">
                      <NumberCounter start={0} end={section.count} duration={section.duration} />
                    </h3>
                    <span>%</span>
                  </div>
                  <h4>{section.title}</h4>
                  <p>{section.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="row">
            <div className="col-lg-12 text-center">
              <Link to="#" className="arrow-btn">
                <i className="fas fa-long-arrow-down"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Aboutarea;
